import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { Dispatch } from "redux"
import { invalidateBillingSettings } from "~Shared/queries/billing.queries"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToPaymentSettings = async (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE || operationType === OperationTypeEnum.DELETE) {
            await invalidateBillingSettings()
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Payment Settings Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
